import React from 'react';
// import PropTypes from 'prop-types';

import Header from './Header';
import CriteriaModal from './CriteriaModal';

const ReportHome = () => (
  <div className="ReportHome">
    <Header />
    <main>
      <div className="CriteriaModal_wrapper">
        <CriteriaModal />
      </div>
    </main>
  </div>
);

export default ReportHome;
